import { render } from "./myDeckDocuments.vue?vue&type=template&id=3caecf8a"
import script from "./myDeckDocuments.vue?vue&type=script&lang=js"
export * from "./myDeckDocuments.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__